export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14147.ee3eb639.jpg";